<template>
  <div class="topic-info app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
      <a-form-model-item label="话题名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入话题名称" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="所属版块" prop="section">
        <a-select v-model="form.section" placeholder="请选择所属版块" :disabled="!!id">
          <a-select-option :value="value.id" v-for="value in sectionOptions" :key="value.id">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="发布社区" prop="community">
        <a-select mode="multiple" v-model="form.community" placeholder="请选择发布社区" :disabled="!isPlatformRole || !!id">
          <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="话题封面" prop="avatar">
        <a-upload name="media" :show-upload-list="false" list-type="picture-card" :action="$uploadUrl" class="app-avatar-uploader" :before-upload="$beforeUpload" @change="handleChange">
          <dy-image :src="form.avatar" v-if="form.avatar" preview></dy-image>
          <a-icon :type="avatar.loading ? 'loading' : 'plus'" v-else></a-icon>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="话题描述" prop="note">
        <a-textarea v-model="form.note" placeholder="请输入话题描述"></a-textarea>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
  import CommunityService from '@/io/community.js';
  import SectionService from '@/io/section.js';
  import TopicService from '@/io/topic.js';

  export default {
    name: 'TopicInfo',
    data() {
      return {
        id: this.$route.params.id,
        avatar: {
          loading: false
        },
        sectionOptions: [],
        communityOptions: [],
        communityOptionsCache: [],
        form: {
          name: null,
          section: [],
          community: [],
          avatar: null,
          note: null
        },
        rules: {
          name: [
            {
              required: true,
              message: '请输入话题名称'
            }
          ],
          section: [
            {
              required: true,
              message: '请选择所属版块'
            }
          ],
          community: [
            {
              required: true,
              message: '请选择发布社区'
            }
          ],
          avatar: [
            {
              required: true,
              message: '请上传话题封面'
            }
          ],
          note: [
            {
              required: true,
              message: '请填写话题描述'
            }
          ],
        }
      }
    },
    watch: {
      'form.section': {
        handler(newValue, oldValue) {
          if (typeof newValue === 'number') {
            let communityId = this.sectionOptions.filter(val => val.id === newValue)[0].community_id;
            this.communityOptions = communityId ? this.communityOptionsCache.filter(val => val.id === communityId) : this.communityOptionsCache;
            this.form.community = this.form.community.filter(val => this.communityOptions.map(m => m.id).indexOf(val) > -1);
          }
        },
        immediate: true
      }
    },
    mounted () {
      Promise.all([
        this.initCommunity(),
        this.initSection()
      ]).then(() => {
        this.initPage();
      });
    },
    methods: {
      initPage() {
        if (this.$getCookie('communityId')) {
          this.form.community = [this.$getCookie('communityId') * 1];
        }
        if (this.id) {
          TopicService.info(null, this.id).then(res => {
            this.form.name = res.meta.topic.content;
            this.form.section = res.meta.topic.category_id;
            this.form.community = res.meta.topic.community_ids;
            this.form.avatar = res.meta.topic.photos[0];
            this.form.note = res.meta.topic.content_desc;
          }).catch(err => {});
        }
      },
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.communityOptionsCache = res;
        }).catch(err => {});
      },
      initSection() {
        return SectionService.list().then(res => {
          this.sectionOptions = res;
        }).catch(err => {});
      },
      handleChange(info) {
        let status = info.file.status;
        if (status) {
          if (status === 'done') {
            this.avatar.loading = false;
            this.form.avatar = info.file.response.media;
          } else {
            this.avatar.loading = true;
          }
        }
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.id) {
            TopicService.edit(
              this.id,
              this.form.name,
              this.form.section,
              this.form.community,
              [this.form.avatar],
              this.form.note
            ).then(res => {
              this.$afterFormSubmit('编辑成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          } else {
            TopicService.add(
              this.form.name,
              this.form.section,
              this.form.community,
              [this.form.avatar],
              this.form.note
            ).then(res => {
              this.$afterFormSubmit('创建成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          }
        });
      },
      cancel() {
        this.$router.push({
          name: 'TopicManage'
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>